// extracted by mini-css-extract-plugin
export var columnItem = "_fi-3";
export var columnItemDraggable = "_fi-5";
export var dragHandle = "_fi-0";
export var dragHandleHovered = "_fi-1";
export var dropdown = "_fi-6";
export var dropdownContent = "_fi-8";
export var dropdownInner = "_fi-7";
export var filterDropdownHeader = "_fi-9";
export var icon = "_fi-2";
export var moveToTopButton = "_fi-4";
export var sectionDivider = "_fi-a";